module.exports = "<style>div .google-visualization-tooltip>ul>li>span{white-space:nowrap}</style> <div id=commonchart flex layout=row layout-align=\"start center\" layout-wrap style=overflow-x:auto></div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/common-chart/views/commonChart.html
// module id = 1412
// module chunks = 453